
import React from 'react';
import { mergeStyles, mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import Toolbar from './Toolbar';

function getToolbarStyle(position, direction) {
    let style = {
        position: 'absolute',
        zIndex: 100
    };
    switch (position) {
        case 'left':
            if (direction === 'reverse') {
                style.bottom = 0;
            }
            break;
        case 'right':
            style.right = 0;
            if (direction === 'reverse') {
                style.bottom = 0;
            }
            break;
        case 'top':
            if (direction === 'reverse') {
                style.right = 0;
            }
            break;
        case 'bottom':
            style.bottom = 0;
            if (direction === 'reverse') {
                style.right = 0;
            }
            break;
        default:
            //nop;
            break;
    }
    return mergeStyles(style);
}

const ContainerWithToolbar = (props) => {

    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flex: '1 0',
            position: 'relative'
        }
    });

    return (
        <div className={classNames.root}>
            <div className={getToolbarStyle(props.toolbarPosition, props.toolbarDirection)}>
                <Toolbar
                    position={props.toolbarPosition}
                    direction={props.toolbarDirection}
                    buttons={props.buttons}
                />
            </div>
            {props.children}
        </div>
    )
}

export default ContainerWithToolbar;
